<template>
    <div>
        <template v-if="!loading">
            <b-row class="justify-content-center">
                <b-col class="px-0 pb-2 col-10 col-md-8 col-lg-8">
                    <b-card>
                        <b-card-title title-tag="h5"
                            title="Data Management Agreement for Warehouse One Airsoft Membership System"></b-card-title>
                        <hr />
                        <h5>Parties Involved</h5>
                        <p><strong>WBAV Events LTD T/A Warehouse One Airsoft</strong> (hereinafter referred to as “the
                            Organization”)<br>
                            Address: Unit 8, Winston Avenue, Croft, Leicestershire, LE10 3PT</p>
                        <p><strong>Members</strong> (hereinafter referred to as “the Members”)</p>

                        <hr />
                        <h5>Purpose and Scope</h5>
                        <p>The purpose of this agreement is to outline the terms and responsibilities related to the
                            management of membership data within the Warehouse One Airsoft system. The scope includes
                            the following:</p>
                        <ul>
                            <li><strong>Membership Records:</strong> The Organization shall manage and maintain accurate
                                records of its members, including personal information such as names, contact details,
                                essential medical information, and membership status.</li>
                        </ul>

                        <hr />
                        <h5>Data Handling and Security</h5>
                        <h6>3.1 Collection and Storage</h6>
                        <ul>
                            <li>The Organization shall collect member data during the registration process.</li>
                            <li>Data will be stored securely in an encrypted database.</li>
                            <li>Backups shall be performed regularly to prevent data loss.</li>
                        </ul>

                        <h6>3.2 Processing</h6>
                        <p>Authorised staff may process member data for the following purposes:</p>
                        <ul>
                            <li>Verifying membership status</li>
                            <li>Communicating with members</li>
                            <li>Organising events and activities</li>
                        </ul>

                        <h6>3.3 Security Measures</h6>
                        <p>The Organization shall implement the following security measures:</p>
                        <ul>
                            <li><strong>Encryption:</strong> Member data shall be encrypted both in transit and at rest.
                            </li>
                            <li><strong>Access Controls:</strong> Only authorised staff shall have access to the
                                database.</li>
                            <li><strong>Regular Audits:</strong> Periodic reviews of access logs and security protocols.
                            </li>
                        </ul>

                        <hr />
                        <h5>Authorised Access</h5>
                        <ul>
                            <li><strong>Authorised Staff:</strong> Only personnel with specific roles (e.g., membership
                                coordinator, event organiser) shall have access to member data.</li>
                            <li><strong>Access Limitations:</strong> Staff members shall access only the information
                                necessary to perform their duties.</li>
                        </ul>

                        <hr />
                        <h5>Emergency Situations</h5>
                        <p>In case of an emergency, the information provided by the member may be passed on to emergency
                            services either verbally or in the form of a printout. This includes essential medical
                            information and contact details necessary for ensuring the member's safety and well-being.
                        </p>

                        <hr />
                        <h5>Member Data Requests</h5>
                        <p>Members can request a copy of the information stored in the system. This request must be
                            submitted in the form of a signed letter and include the member's number to aid in
                            confirming their identity.</p>
                        <p>Once the identity of the member is confirmed, the information will be provided to the
                            registered member's email address via a secure link.</p>
                        <p>It may take up to 14 days to process the request from the date the letter is received.</p>

                        <hr />
                        <h5>Duration and Termination</h5>
                        <p>This agreement shall remain in effect until terminated by either party. Termination may occur
                            due to:</p>
                        <ul>
                            <li>Expiration (e.g., annually)</li>
                            <li>Breach of terms</li>
                            <li>Mutual agreement</li>
                        </ul>
                        <hr />
                        <p class="text-muted"><small>Agreement Version Date 22/09/2024</small></p>

                        <div class="text-right">
                            <b-form-checkbox v-model="agreementAccepted" required>
                                I have read and agree to the terms outlined in this agreement.
                            </b-form-checkbox>
                            <b-button variant="primary" @click="processAgreement" :disabled="!agreementAccepted">Accept
                                Agreement</b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            agreementAccepted: false,
            loading: false,
        }
    },
    methods: {
        processAgreement() {
            if (this.agreementAccepted) {
                axios.post(this.$routes.route('bookings.agreement.process'), {agreement: this.agreementAccepted})
                .then((response) => {
                    if (response.data.success) {
                        // Redirect the page to this.$routes.route('bookings.calendar');
                        window.location.href = this.$routes.route('bookings.calendar');
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        },
        init() {
            this.loading = false;
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    }
}
</script>